// TODO VSO 66845 : Split up todo service constants into service files
export const TODO_API_ROOT = '/ows/todo/api/v1';

const TODO_API_TASK = '/tasks/{0}';
const TODO_API_TASKFOLDER = '/taskfolders/{0}';
const TODO_API_TASKFOLDERS = '/taskfolders';
const TODO_API_TASKS_IN_FOLDER = '/taskfolders/{0}/tasks';
const TODO_API_SUBTASK_ROOT = '/subtasks';
const TODO_API_SUBTASK = '/subtasks/{1}';

export const TODO_API_DEFAULT_FOLDER = 'tasks';
export const TODO_API_GET_TASK_FORMAT = TODO_API_ROOT + TODO_API_TASK;
export const TODO_API_DELETE_TASK_FORMAT = TODO_API_ROOT + TODO_API_TASK;
export const TODO_API_UPDATE_TASK_FORMAT = TODO_API_ROOT + TODO_API_TASK;
export const TODO_API_UPDATE_TASKFOLDER = TODO_API_ROOT + TODO_API_TASKFOLDER;
export const TODO_API_GET_LISTS = TODO_API_ROOT + TODO_API_TASKFOLDERS;
export const TODO_API_CREATE_TASK_IN_FOLDER_FORMAT = TODO_API_ROOT + TODO_API_TASKS_IN_FOLDER;

export const TODO_API_CREATE_SUBTASK_FORMAT = TODO_API_ROOT + TODO_API_TASK + TODO_API_SUBTASK_ROOT;
export const TODO_API_UPDATE_SUBTASK_FORMAT = TODO_API_UPDATE_TASK_FORMAT + TODO_API_SUBTASK;
export const TODO_API_DELETE_SUBTASK_FORMAT = TODO_API_DELETE_TASK_FORMAT + TODO_API_SUBTASK;
